import type { QueryClient } from "@tanstack/react-query";

/**
 * Drops cached queries that reference a restaurant id anywhere in the query key.
 * Safer than `queryClient.clear()` on restaurant switch; preserves unrelated caches.
 */
export function removeQueriesForRestaurant(
  queryClient: QueryClient,
  restaurantId: string
): void {
  queryClient.removeQueries({
    predicate: (q) => {
      const key = q.queryKey;
      if (!Array.isArray(key)) return false;
      return key.some((segment) => segment === restaurantId);
    },
  });
}
